import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputAdditionalComponent } from './input-additional.component';
import { InputsGeneratorModule } from '../inputs-generator/inputs-generator.module';
import { createCustomElement } from '@angular/elements';
import { SanitizePipeModule } from '@digistore/ds24-ui/pipes';

@NgModule({
  declarations: [InputAdditionalComponent],
  imports: [CommonModule, InputsGeneratorModule, SanitizePipeModule],
})
export class InputAdditionalModule {
  static initialize(injector: Injector) {
    const customComponent = createCustomElement(InputAdditionalComponent, {
      injector: injector,
    });
    customElements.define('ds-orderform-input-additional', customComponent);
  }
}
